import React, {Component} from "react";
import {connect} from "react-redux";
import SVGIcon from "../svg/SVGIcon";
import {NAV, FUTURE_DISCLAIMER} from "../../helpers/consts";
import {withRouter, Link} from 'react-router-dom';

import "./SubNavTabs.css";
import Source from "../items/Source";
import CarouselItem from "../blocks/CarouselItem";

class SubNavTabs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hidden: false
    }
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  render() {
    const {navFixed, children, baseUrl, hashParts} = this.props;
    const activeTab = hashParts.section;
    const options = NAV.subnav ? NAV.subnav:[];
    return (
      <div>
        <div id="fow-subnav-placeholder">
          <div id="fow-subnav" className={`fow-subnav-${navFixed ? 'fixed' : 'static'}`}>
            <div className="fow-inner-container">
              <ul id="fow-view-subnav" className="fow-row">
                {
                  options.map((view)=>
                    <li key={view.slug}>
                      <Link to={`?page=${baseUrl}/${view.slug}`} className={`fow-subnav-item fow-subnav-item-full ${(activeTab === view.slug) ? 'fow-subnav-item-selected' : ''}`}>
                        {view.icon &&
                          <span className="fow-subnav-logo"><SVGIcon name={view.icon} stroke={"#000"} /></span>
                        }
                        {view.name &&
                          <span className="fow-subnav-label fow-font-text fow-font-size-md">{view.name}</span>
                        }
                      </Link>
                    </li>
                  )
                }
              </ul>
            </div>
          </div>
        </div>
        <div className="fow-inner-container">
          <div className="fow-row fow-subnav-content-container">
            {
              NAV.subnav[0].slug === activeTab &&
              <>{children[0]}</>
            }
            {
              NAV.subnav[1].slug === activeTab &&
              <>{children[1]}</>
            }
            {
              NAV.subnav[2].slug === activeTab &&
              <>
                {children[2]}
                <CarouselItem title={false} subtitle={false} showSelected={false}>
                  <div className="fow-col fow-col-1">
                    <Source text={FUTURE_DISCLAIMER} />
                  </div>
                </CarouselItem>
              </>
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    navFixed: state.settings.navFixed,
    hashParts: state.settings.hashParts
  };
};
const mapDispatchToProps = dispatch => ({

});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubNavTabs));
